export default "__VITE_ASSET__BFKc_zTJ__"